import { Box, type SxProps, type Theme } from "@mui/material";

type DashSeparatorProps = {
  sx?: SxProps<Theme>;
} & React.ComponentProps<typeof Box>;

const DashSeparator = (props: DashSeparatorProps) => {
    return <Box bgcolor={"primary.main"} width={24} height={4} borderRadius={16} {...props}/>;
};

export default DashSeparator;